module.exports = __webpack_public_path__ + "static/logo-light-mobil-286c3ebb43d33c8243cedf9bb4ae1ac1.png";